// A persistent banner shown while a Super Admin is impersonating another person
// via "View as". It lives outside the normal nav because impersonating a plain
// user hides the admin controls — the Exit button here is always available to
// return to the admin's own identity.
import { Alert, Button, Box, FormControlLabel, Switch, Stack } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useMe } from "../MeContext";
import { useViewAs } from "../ViewAsContext";

export default function ViewAsBanner() {
  const { me } = useMe();
  const { allowWrites, setWrites, stop } = useViewAs();

  if (!me?.impersonating) return null;

  const who = me.name || me.email || `person #${me.personnel_id}`;
  const mode = me.read_only ? "read-only" : "writes enabled — audited";

  return (
    <Box sx={{ px: 2, pt: 1 }}>
      <Alert
        severity={me.read_only ? "info" : "warning"}
        icon={<VisibilityIcon fontSize="inherit" />}
        action={
          <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <FormControlLabel
              sx={{ mr: 0 }}
              control={
                <Switch
                  size="small"
                  color="warning"
                  checked={allowWrites}
                  onChange={(e) => setWrites(e.target.checked)}
                />
              }
              label="Allow writes"
            />
            <Button color="inherit" size="small" onClick={stop}>
              Exit view as
            </Button>
          </Stack>
        }
      >
        Viewing as <strong>{who}</strong> ({mode}). You see and can do only what
        this person can.
      </Alert>
    </Box>
  );
}
